<div class="form-field">
  <fieldset [class.disabled]="disabled">
    <input type="date"
           [disabled]="disabled"
           [required]="required"
           [value]="selectedDate"
           [min]="minDate"
           (change)="onDateChange($event)"
           [name]="label" />
    <legend *ngIf="label">{{ label }}</legend>
  </fieldset>
  @if (errorMessage) {
  <div class="date-error">{{ errorMessage }}</div>
  }
</div>
